export default {
  API_ENDPOINT: `https://cryptic-forest-75768.herokuapp.com/api`,
  TOKEN_KEY: 'process.env.REACT_APP_API_KEY',
}
//http://localhost:8000/api
//https://cryptic-forest-75768.herokuapp.com/api